import React from 'react';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import '../../styles/cart.css';

const Cart = ({ onCheckout }) => {
  const { 
    items, 
    subtotal, 
    tax, 
    discount, 
    total,
    customer,
    updateQuantity, 
    removeFromCart,
    setDiscount,
    setNotes,
    notes
  } = useCart();
  
  const { hasPermission } = useAuth();

  const handleDiscountChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setDiscount(value);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES'
    }).format(amount);
  };

  return (
    <div className="cart">
      <div className="cart-header">
        <h3>Current Sale</h3>
        {customer && (
          <div className="cart-customer">
            <span className="customer-badge">
              {customer.first_name} {customer.last_name}
            </span>
          </div>
        )}
      </div>

      <div className="cart-items">
        {items.length === 0 ? (
          <div className="empty-cart">
            <span className="empty-icon">🛒</span>
            <p>Cart is empty</p>
            <p className="empty-hint">Scan barcode or search products</p>
          </div>
        ) : (
          items.map((item) => (
            <div key={item.id} className="cart-item">
              <div className="item-info">
                <div className="item-name">{item.product_name}</div>
                <div className="item-price">{formatCurrency(item.selling_price)}</div>
              </div>

              <div className="item-actions">
                <button 
                  className="quantity-btn"
                  onClick={() => updateQuantity(item.id, item.quantity - 1)}
                  disabled={item.quantity <= 1}
                >
                  -
                </button>
                <input
                  type="number"
                  value={item.quantity}
                  onChange={(e) => updateQuantity(item.id, parseInt(e.target.value) || 1)}
                  min="1"
                  max={item.current_stock}
                  className="quantity-input"
                />
                <button 
                  className="quantity-btn"
                  onClick={() => updateQuantity(item.id, item.quantity + 1)}
                  disabled={item.quantity >= item.current_stock}
                >
                  +
                </button>
                <button 
                  className="remove-btn"
                  onClick={() => removeFromCart(item.id)}
                >
                  ×
                </button>
              </div>

              <div className="item-total">
                {formatCurrency(item.selling_price * item.quantity)}
              </div>

              {item.quantity >= item.current_stock && (
                <div className="stock-warning">Max stock reached</div>
              )}
            </div>
          ))
        )}
      </div>

      <div className="cart-footer">
        <div className="cart-summary">
          <div className="summary-row">
            <span>Subtotal:</span>
            <span>{formatCurrency(subtotal)}</span>
          </div>

          <div className="summary-row">
            <span>Tax:</span>
            <span>{formatCurrency(tax)}</span>
          </div>

          <div className="summary-row discount">
            <span>Discount:</span>
            {hasPermission('manage_settings') ? (
              <input
                type="number"
                value={discount}
                onChange={handleDiscountChange}
                placeholder="0"
                min="0"
                max={subtotal}
                className="discount-input"
              />
            ) : (
              <span>{formatCurrency(discount)}</span>
            )}
          </div>

          <div className="summary-row total">
            <span>Total:</span>
            <span className="total-amount">{formatCurrency(total)}</span>
          </div>
        </div>

        <div className="cart-notes">
          <textarea
            placeholder="Add notes to sale..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows="2"
          />
        </div>

        <button 
          className="checkout-btn"
          onClick={onCheckout}
          disabled={items.length === 0}
        >
          Checkout • {formatCurrency(total)}
        </button>
      </div>
    </div>
  );
};

export default Cart;